import React from 'react';

class w3skull extends React.Component {
    constructor(props){
        super(props);
        this.state={username: ''};
    }
    replaceName = (name)=>{
        this.setState({username: name.target.value})
    }
    render(){
        let header = '';
        if (this.state.username){
            header = <h1>Yeah {this.state.username}</h1>
        }else{
            header=''
        }
        return(
            <form>
                {header}
                < input type="text" onChange={this.replaceName}/>
            </form>
        )
    }
}

export default w3skull;
